module.exports = __webpack_public_path__ + "images/help/video-kanban-small@2x-2ea4400d9cd9cbea9c2665bd0a97dd37.png";